import DetailsCardComponent, {
	DetailsType,
	CardDetail,
	Detail,
} from './DetailsCardComponent';
export default DetailsCardComponent;
export { DetailsType };
export type { CardDetail, Detail };
